// src/ConsumerApp/api/search/search.hooks.js
import { useQuery } from '@tanstack/react-query';
import { SearchService } from './search.service';

export const useGlobalSearch = (search, { page = 1, pageSize = 20 } = {}) => {
  const queryTerm = search?.trim() || '';
  return useQuery({
    queryKey: ['globalSearch', queryTerm, page, pageSize],
    queryFn: async () => {
      const response = await SearchService.globalSearch({
        search: queryTerm,
        page,
        pageSize,
      });
      const list =
        response?.data?.data?.products ||
        response?.data?.products ||
        response?.products ||
        response?.data ||
        [];
      return Array.isArray(list) ? list : [];
    },
    enabled: queryTerm.length >= 3,
    staleTime: 1000 * 60 * 2, // 2 minutes cache
  });
};